import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';

/**
 * Applies ?company= after companies load. Invalid values are ignored.
 */
const CompanyQuerySync = () => {
  const [searchParams] = useSearchParams();
  const { companies, activeCompany, switchCompany } = useAuth();

  useEffect(() => {
    const companyParam = searchParams.get('company');
    if (!companyParam || companies.length === 0) return;
    const match = companies.find((c) => String(c.id) === companyParam);
    if (!match) return;
    if (String(activeCompany?.id) === String(match.id)) return;
    switchCompany(match);
  }, [searchParams, companies, activeCompany?.id, switchCompany]);

  return null;
};

export default CompanyQuerySync;
